import { useEffect, useMemo, useState } from 'react';
import { TopPnlChart } from '../../game-detail/TopPnlChart';
import { useGetIdentity, useTranslate } from 'react-admin';
import { UserModel } from 'src/pages/admin/entities/user.entity';
import useTop5Player from '../hooks/useTop5Player';
import _ from 'lodash';
import { ApexOptions } from 'apexcharts';
import { scaleSymlog } from 'd3-scale';

interface DashboardTopPlayChartProps {
  filterValues: any;
  isLoading: boolean;
}

export const DashboardTop5PlayChart = ({ filterValues, isLoading }: DashboardTopPlayChartProps) => {
  const translate = useTranslate();
  const { data: userData } = useGetIdentity();
  const user = userData as UserModel;
  const { data: top5PlayerData, loading } = useTop5Player(filterValues);

  const dataChartRevenue = useMemo(() => {
    if (top5PlayerData.data) {
      return {
        categories: top5PlayerData.data.categories,
        series: top5PlayerData.data.series,
      };
    }
    return null;
  }, [top5PlayerData]);

  if (loading || !dataChartRevenue) {
    return <></>;
  }

  return <TopPnlChart title="Top PNL" chart={dataChartRevenue} />;
};
